export default __webpack_public_path__ + "static/media/rice07.0ee5aa93.png";